import { authenticatedApi, unauthenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

export const login_api = async (payload) => {
	return new Promise((resolve, reject) => {
		unauthenticatedApi
			.post(`${MICROSERVICE_CONFIG.AUTH}/login/admin`, payload)
			.then((response) => {
				let { data } = response;
				resolve(data);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const refreshToken_api = async (payload) => {
	return new Promise((resolve, reject) => {
		unauthenticatedApi
			.post(`${MICROSERVICE_CONFIG.AUTH}/refresh-token/admin`, payload)
			.then((response) => {
				let { data } = response;
				localStorage.setItem("token", data?.data?.access_token);
				resolve(data);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const forgotPasssword_api = async (payload) => {
	return new Promise((resolve, reject) => {
		unauthenticatedApi
			.post(`${MICROSERVICE_CONFIG.AUTH}/forgot-password/email`, payload)
			.then((response) => {
				let { data } = response;
				resolve(data);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const verifyResetToken_api = async ({ forgotToken }) => {
	return new Promise((resolve, reject) => {
		unauthenticatedApi
			.post(
				`${MICROSERVICE_CONFIG.AUTH}/reset-password/email/${forgotToken}/verify`
			)
			.then((response) => {
				let { data } = response;
				resolve(data);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const updatePassword_api = async (body) => {
	return new Promise((resolve, reject) => {
		unauthenticatedApi
			.post(`${MICROSERVICE_CONFIG.AUTH}/update-password/email`, body)
			.then((response) => {
				let { data } = response;
				resolve(data);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const deleteUser_api = async (id) => {
	const response = await authenticatedApi.delete(
		`${MICROSERVICE_CONFIG.AUTH}/user/${id}`
	);
	return response.data;
};
